/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Cart-Drawer qty: nur Zahl, kein "Gegenstand/Gegenstände"
  function stripCartDrawerQtyText() {
    const el = document.querySelector('#cart-drawer [data-cart-items-qty]');
    if (!el) return;
    const match = el.textContent.trim().match(/\d+/);
    if (match && el.textContent.trim() !== match[0]) {
      el.textContent = match[0];
    }
  }
  document.addEventListener('DOMContentLoaded', stripCartDrawerQtyText);
  document.addEventListener('theme:cart:loaded', stripCartDrawerQtyText);
  document.addEventListener('theme:cart:added', stripCartDrawerQtyText);


/**
 * Toggle card scrolling effect based on screen size
 * - Enabled on desktop (>= 768px)
 * - Disabled on mobile (< 768px)
 */
function handleCardScrollingEffect() {
  // Only run if the setting is enabled
  if (!document.querySelector('[data-disable-card-scrolling-on-mobile]')) return;
  
  const isMobile = window.innerWidth < 768;
  const bannerSection = document.querySelector('[data-disable-card-scrolling-on-mobile]');
  
  if (!bannerSection) return;

  // Store original classes for restoration
  if (!bannerSection.dataset.originalClasses) {
    // Save the original classes on first run
    bannerSection.dataset.originalClasses = bannerSection.className;
  }
  
  if (isMobile) {
    // Disable card scrolling effect on mobile
    bannerSection.classList.remove('card-scrolling-effect');
    bannerSection.classList.remove('card-scrolling-effect--rounded-large');
  } else {
    // Enable on desktop - restore from original classes
    const hasCardScrolling = bannerSection.dataset.originalClasses.includes('card-scrolling-effect');
    const hasRoundedLarge = bannerSection.dataset.originalClasses.includes('card-scrolling-effect--rounded-large');
    
    if (hasCardScrolling) {
      bannerSection.classList.add('card-scrolling-effect');
    }
    
    if (hasRoundedLarge) {
      bannerSection.classList.add('card-scrolling-effect--rounded-large');
    }
    
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  handleCardScrollingEffect();
  
  // Re-check on window resize
  window.addEventListener('resize', function() {
    handleCardScrollingEffect();
  });
});







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


class SubscriptionManager extends HTMLElement {
  constructor() {
    super();
    this.subscribeOption = this.querySelector('.subscription-item__subscribe');
    this.onetimeOption = this.querySelector('.subscription-item__one-time-purchase');
    this.isSubscriptionActive = false;
    this.currentQuantity = 1;
    this.widget = this.querySelector('.loop-subscription-container');
    this.badge1El = document.querySelector('.quantity-selector__boxes .quantity-selector__box[data-quantity="1"] .l-badge');
    this.badge2El = document.querySelector('.quantity-selector__boxes .quantity-selector__box[data-quantity="2"] .l-badge');
    this.badge3El = document.querySelector('.quantity-selector__boxes .quantity-selector__box[data-quantity="3"] .l-badge');


    // prices selectors:
    this.price1El = document.querySelector('.quantity-selector__boxes .quantity-selector__box[data-quantity="1"] .l-price .l-price-value');
    this.price2El = document.querySelector('.quantity-selector__boxes .quantity-selector__box[data-quantity="2"] .l-price .l-price-value');
    this.price3El = document.querySelector('.quantity-selector__boxes .quantity-selector__box[data-quantity="3"] .l-price .l-price-value');

    // read attributes (string) and normalize
    const _one_time_purchase_prices_el = this.querySelector('.subscription--wrapper');
    const a1 = _one_time_purchase_prices_el.getAttribute('data-price-qty-1');
    const a2 = _one_time_purchase_prices_el.getAttribute('data-price-qty-2');
    const a3 = _one_time_purchase_prices_el.getAttribute('data-price-qty-3');
    this.badge1 = _one_time_purchase_prices_el.getAttribute('data-badge-1');
    this.badge2 = _one_time_purchase_prices_el.getAttribute('data-badge-2');
    this.badge3 = _one_time_purchase_prices_el.getAttribute('data-badge-3');
    this.badge1_sub = _one_time_purchase_prices_el.getAttribute('data-badge-1-sub');
    this.badge2_sub = _one_time_purchase_prices_el.getAttribute('data-badge-2-sub');
    this.badge3_sub = _one_time_purchase_prices_el.getAttribute('data-badge-3-sub');


    this.oneTimePurchasePriceQty1 = a1 ? a1.trim() : null;
    this.oneTimePurchasePriceQty2 = a2 ? a2.trim() : null;
    this.oneTimePurchasePriceQty3 = a3 ? a3.trim() : null;

    this.subscriptionPriceQty1 = this.widget.querySelector('[id^="loop-selling_plan_group"]:first-child .loop-subscription-group-price-amount');
    this.subscriptionPriceQty2 = this.widget.querySelector('[id^="loop-selling_plan_group"]:nth-child(2) .loop-subscription-group-price-amount');
    this.subscriptionPriceQty3 = this.widget.querySelector('[id^="loop-selling_plan_group"]:nth-child(3) .loop-subscription-group-price-amount');

    this.badge1El.textContent = this.badge1_sub;
    this.badge2El.textContent = this.badge2_sub;
    this.badge3El.textContent = this.badge3_sub;

    this.price1El.textContent = this.formatPrice(this.subscriptionPriceQty1.textContent);
    this.price2El.textContent = this.formatPrice(this.subscriptionPriceQty2.textContent);
    this.price3El.textContent = this.formatPrice(this.subscriptionPriceQty3.textContent);


    if(this.badge1El.textContent.trim() === '') {
      this.badge1El.style.display = 'none';
    } else {
      this.badge1El.style.display = 'inline-block';
    }
  }

  connectedCallback() {
    this.setupEventListeners();
    
    // Initialize with default state
    this.activateSubscription();
    this.updateOneTimePurchaseBlockPrice();
  }

  setupEventListeners() {
    if (this.subscribeOption) {
      this.subscribeOption.addEventListener('click', () => {
        this.activateSubscription();
        // select inner radio button
        const innerRadio = this.subscribeOption.querySelector('input[type="radio"]');
        if (innerRadio) {
          innerRadio.checked = true;
        }
      });
    }

    if (this.onetimeOption) {
      this.onetimeOption.addEventListener('click', () => {
        this.deactivateSubscription();
        const innerRadio = this.onetimeOption.querySelector('input[type="radio"]');
        if (innerRadio) {
          innerRadio.checked = true;
        }
      });
    }

    // Listen for quantity changes
    document.addEventListener('quantity-changed', (event) => {
      const quantity = event.detail.quantity || 1;
      this.currentQuantity = quantity;
      
      // Update Loop subscription if active
      if (this.isSubscriptionActive) {
        this.activateSubscription();
      }
    });
    
    // Listen for clicks on quantity selector boxes
    const quantityBoxes = document.querySelectorAll('[data-quantity-box]');
    if (quantityBoxes.length > 0) {
      quantityBoxes.forEach(box => {
        box.addEventListener('click', (e) => {
          const quantity = parseInt(e.currentTarget.dataset.quantity, 10) || 1;
          this.currentQuantity = quantity;
          
          // Update plan if subscription is active
          if (this.isSubscriptionActive) {
            setTimeout(() => this.activateSubscription(), 50);
          } else {
            // just populate selling plan data if not subscribed
            this.populateSellingPlanData();
          }
          this.updateOneTimePurchaseBlockPrice();
        });
      });
    }

    // activate subscribtion
    const _activate_button = document.querySelector(".subscription-activator");
    _activate_button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.subscribeOption.click();
    })
  }

  activateSubscription() {
    // Find the Loop container
    const loopContainer = document.querySelector('.loop-subscription-container');
    if (!loopContainer) {
      console.warn('Could not find Loop container');
      return;
    }

    // Update our UI first
    this.updateCustomUI(true);
    this.dispatchEvent(true);
    
    // Directly find the specific subscription plan radio based on quantity
    setTimeout(() => {
      // Find all the subscription plan radio buttons
      const planRadios = loopContainer.querySelectorAll('input[type="radio"]');
      if (planRadios.length) {
        let targetRadio = null;
        
        if (this.currentQuantity === 1) {
          // Find Abonnement 1 radio button
          targetRadio = Array.from(planRadios).find(radio => 
            radio.dataset.name === 'Abonnement 1' || 
            radio.dataset.name?.toLowerCase().includes('30')
          );
        } else if (this.currentQuantity === 2) {
          // Find Abonnement 2 radio button
          targetRadio = Array.from(planRadios).find(radio => 
            radio.dataset.name === 'Abonnement 2' || 
            radio.dataset.name?.toLowerCase().includes('60')
          );
        } else if (this.currentQuantity >= 3) {
          // Find Abonnement 3 radio button
          targetRadio = Array.from(planRadios).find(radio => 
            radio.dataset.name === 'Abonnement 3' || 
            radio.dataset.name?.toLowerCase().includes('90')
          );
        }
        
        // If we found a matching radio, click it
        if (targetRadio) {
          console.log(`Selecting subscription plan: ${targetRadio.dataset.name}`);
          targetRadio.click();
          this.populateSellingPlanData();
          this.badge1El.textContent = this.badge1_sub;
          this.badge2El.textContent = this.badge2_sub;
          this.badge3El.textContent = this.badge3_sub;

          if(this.badge1El.textContent.trim() === '') {
            this.badge1El.style.display = 'none';
          } else {
            this.badge1El.style.display = 'inline-block';
          }

          this.subscriptionPriceQty1 = this.widget.querySelector('[id^="loop-selling_plan_group"]:first-child .loop-subscription-group-price-amount');
          this.subscriptionPriceQty2 = this.widget.querySelector('[id^="loop-selling_plan_group"]:nth-child(2) .loop-subscription-group-price-amount');
          this.subscriptionPriceQty3 = this.widget.querySelector('[id^="loop-selling_plan_group"]:nth-child(3) .loop-subscription-group-price-amount');

          this.price1El.textContent = this.formatPrice(this.subscriptionPriceQty1.textContent);
          this.price2El.textContent = "Je " + this.formatPrice(this.subscriptionPriceQty2.textContent);
          this.price3El.textContent = "Je " + this.formatPrice(this.subscriptionPriceQty3.textContent);

        } else {
          console.warn('No matching subscription radio found');
        }
      } else {
        console.warn('No radio buttons found in Loop container');
      }
    }, 50);
  }

  populateSellingPlanData() {
    if(!this.widget) {
      return;
    }
    let priceData = this.widget.querySelector(`[id^="loop-selling_plan_group"]:nth-child(${this.currentQuantity}) .loop-subscription-group-price-amount`);

    if(priceData) {
      priceData = this.formatPrice(priceData.textContent);
      this.subscribeOption.querySelector('.l-price span').innerHTML = priceData;
    }

    // benefits data
    if(this.currentQuantity === 1) {
      this.subscribeOption.querySelector('.selling-plan').innerHTML = '30 Tage';

    } else if(this.currentQuantity === 2) {
      this.subscribeOption.querySelector('.selling-plan').innerHTML = '2 Monate';
    } else {
      this.subscribeOption.querySelector('.selling-plan').innerHTML = '3 Monate';
    }

  }

  deactivateSubscription() {
    // Find the Loop container
    const loopContainer = document.querySelector('#loop-subscription-container-8380965060888');
    if (!loopContainer) {
      console.warn('Could not find Loop container');
      return;
    }

    // Update our UI first
    this.updateCustomUI(false);
    this.dispatchEvent(false);
    this.badge1El.textContent = this.badge1;
    this.badge2El.textContent = this.badge2;
    this.badge3El.textContent = this.badge3;
    if(this.badge1El.textContent.trim() === '') {
      this.badge1El.style.display = 'none';
    } else {
      this.badge1El.style.display = 'inline-block';
    }

    this.price1El.textContent = this.formatPrice(this.oneTimePurchasePriceQty1);
    this.price2El.textContent = "Je " + this.formatPrice(this.oneTimePurchasePriceQty2);
    this.price3El.textContent = "Je " + this.formatPrice(this.oneTimePurchasePriceQty3);

    // Find and click the one-time purchase radio in the Loop widget
    setTimeout(() => {
      // Try with more specific selector first
      let onetimeRadio = loopContainer.querySelector('.loop-one-time-purchase-option input[type="radio"]');
      
      // Fallback to other selectors if not found
      if (!onetimeRadio) {
        onetimeRadio = loopContainer.querySelector('.loop-option-radio.loop-one-time-radio');
      }
      
      if (!onetimeRadio) {
        onetimeRadio = loopContainer.querySelector('input[type="radio"][data-name="One-time purchase"]');
      }
      
      if (onetimeRadio) {
        // Click the Loop widget's one-time radio
        onetimeRadio.click();

        // populate one time price:
        this.updateOneTimePurchaseBlockPrice();
      } else {
        console.warn('Could not find one-time purchase radio button');
      }
    }, 50);
  }

  updateOneTimePurchaseBlockPrice() {

    let _price = null;

    if(this.currentQuantity === 1 && this.oneTimePurchasePriceQty1) {
      _price = this.oneTimePurchasePriceQty1;
    } else if(this.currentQuantity === 2 && this.oneTimePurchasePriceQty2) {
      _price = this.oneTimePurchasePriceQty2;
    } else if(this.currentQuantity === 3 && this.oneTimePurchasePriceQty3) {
      _price = this.oneTimePurchasePriceQty3;
    }

    if(_price) {
      this.onetimeOption.querySelector('.l-price span').innerHTML = '€' + _price;
    }
  }

  formatPrice(priceTextContent) {
    try {
      let _price = priceTextContent;
      _price = _price.split(',')[0];
      _price = _price.trim();

      if (_price.startsWith('€')) {
        _price = _price.replace('€ ', '€').trim();
        return _price
      }

      _price = " €" + _price;
  
      return _price;
    } catch(e) {
      console.log('Error formatting price:', e);
    }
  }
  
  updateCustomUI(isSubscription) {
    if (isSubscription) {
      this.subscribeOption.classList.add('is-active');
      this.onetimeOption.classList.remove('is-active');
      this.isSubscriptionActive = true;
    } else {
      this.onetimeOption.classList.add('is-active'); 
      this.subscribeOption.classList.remove('is-active');
      this.isSubscriptionActive = false;
    }
  }

  dispatchEvent(isSubscription) {
    const event = new CustomEvent('subscription:plan-changed', {
      detail: {
        isSubscription: isSubscription,
        quantity: this.currentQuantity,
        planType: isSubscription ? 'subscription' : 'one-time'
      }
    });
    document.dispatchEvent(event);
  }
}

customElements.define('subscription-manager', SubscriptionManager);

class BubbleCount extends HTMLElement {
  constructor() {
    super();
    this.numberElement = this.querySelector('.bubble-count__number');
  }

  connectedCallback() {
    this.observeCartQty();
  }

  observeCartQty() {
    // Listen for cart drawer reloads which happen after AJAX updates
    document.addEventListener('theme:cart:loaded', () => {
      this.updateBubbleCount();
    });
    
    // Listen for cart add events
    document.addEventListener('theme:cart:added', () => {
      this.updateBubbleCount();
    });
    
    // Initial update
    this.updateBubbleCount();
  }

  updateBubbleCount() {
    if (!this.numberElement) return;
    
    const cartQtyElement = document.querySelector('[data-cart-items-qty]');
    if (!cartQtyElement) return;
    
    // Extract number from cart qty text (e.g., "3 items" -> "3")
    const text = cartQtyElement.textContent.trim();
    const match = text.match(/(\d+)/);
    if (match) {
      const count = parseInt(match[1]);
      this.numberElement.textContent = count;

      // Show/hide bubble based on count
      if (count > 0) {
        this.removeAttribute('hidden');
      } else {
        this.setAttribute('hidden', '');
      }
    }
  }
}

/* ================================================================
   Purchase Module (neue konsolidierte Logik)
   Ersetzt SubscriptionManager für Templates die purchase_module + purchase_footer nutzen.
   Altes SubscriptionManager bleibt für Legacy-Templates (kollapro, matcha, b2b) aktiv.
   ================================================================ */
class PurchaseModule {
  constructor(root) {
    this.root = root;
    this.init();
  }

  init() {
    const getAttr = (name) => this.root.getAttribute(name);
    const num = (v) => {
      const n = parseInt(v, 10);
      return isNaN(n) ? 0 : n;
    };
    this.subEnabled = getAttr('data-sub-enabled') === 'true';
    this.currentQuantity = 1;
    this.isSubscription = this.subEnabled;
    this.divisor = num(getAttr('data-divisor')) || 30;

    this.prices = {
      ot: { 1: num(getAttr('data-ot-price-1')), 2: num(getAttr('data-ot-price-2')), 3: num(getAttr('data-ot-price-3')) },
      otCompare: { 1: num(getAttr('data-ot-compare-1')), 2: num(getAttr('data-ot-compare-2')), 3: num(getAttr('data-ot-compare-3')) },
      sub: { 1: num(getAttr('data-sub-price-1')), 2: num(getAttr('data-sub-price-2')), 3: num(getAttr('data-sub-price-3')) },
    };
    this.badges = {
      ot: { 1: getAttr('data-badge-ot-1') || '', 2: getAttr('data-badge-ot-2') || '', 3: getAttr('data-badge-ot-3') || '' },
      sub: { 1: getAttr('data-badge-sub-1') || '', 2: getAttr('data-badge-sub-2') || '', 3: getAttr('data-badge-sub-3') || '' },
    };

    this.boxes = this.root.querySelectorAll('[data-pm-qty-box]');
    this.priceDisplay = this.root.querySelector('[data-pm-price-display]');
    this.totalPriceEl = this.root.querySelector('[data-pm-total-price]');
    this.comparePriceEl = this.root.querySelector('[data-pm-compare-price]');
    this.unitPriceEl = this.root.querySelector('[data-pm-unit-price]');
    this.giftCards = this.root.querySelectorAll('[data-pm-gift-card]');
    this.giftModule = this.root.querySelector('[data-pm-gift-module]');
    this.giftReactivateBtn = this.root.querySelector('[data-pm-reactivate-sub]');

    this.footer = document.querySelector('[data-purchase-footer]');
    this.footerToggleBtn = this.footer ? this.footer.querySelector('[data-pm-toggle-purchase]') : null;
    this.footerToggleLabel = this.footer ? this.footer.querySelector('[data-pm-toggle-label]') : null;

    this.atcPricesEl = document.querySelector('[data-atc-dynamic-prices]');
    this.atcTotalEl = document.querySelector('[data-atc-total-price]');
    this.atcCompareEl = document.querySelector('[data-atc-compare-price]');

    this.productForm = document.querySelector('form[action*="/cart/add"]');
    this.formQtyInput = this.productForm ? this.productForm.querySelector('input[name="quantity"]') : null;
    if (this.productForm && !this.formQtyInput) {
      // Inject hidden qty input if missing
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      this.productForm.appendChild(input);
      this.formQtyInput = input;
    }

    this.loopWidget = document.querySelector('.loop-subscription-container');

    if (this.subEnabled && this.productForm) {
      const pid = this.productForm.querySelector('input[name="id"]');
      if (pid) {
        const vid = pid.value;
        const jsonEl = document.querySelector(`script.loopProductQuickJson-${vid}`)
          || document.querySelector('script[class^="loopProductQuickJson-"]');
        if (jsonEl) {
          const prodId = jsonEl.className.replace('loopProductQuickJson-', '');
          this.productForm.setAttribute('data-loop-product-id', prodId);
        }
      }
    }

    this.bindEvents();
    this.render();

    this._waitForLoopWidget();
  }

  bindEvents() {
    this.boxes.forEach((box) => {
      box.addEventListener('click', () => {
        const q = parseInt(box.dataset.quantity, 10);
        this.setQuantity(q);
      });
    });

    if (this.footerToggleBtn) {
      this.footerToggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.setSubscription(!this.isSubscription);
      });
    }

    if (this.giftReactivateBtn) {
      this.giftReactivateBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.setSubscription(true);
      });
    }
  }

  setQuantity(q) {
    if (q < 1 || q > 3) return;
    this.currentQuantity = q;
    this.render();
    this.syncLoopWidget();
    document.dispatchEvent(new CustomEvent('quantity-changed', { detail: { quantity: q } }));
  }

  setSubscription(isSub) {
    if (!this.subEnabled) return;
    this.isSubscription = isSub;
    this.render();
    this.syncLoopWidget();
    document.dispatchEvent(new CustomEvent('subscription:plan-changed', {
      detail: { isSubscription: isSub, quantity: this.currentQuantity }
    }));
  }

  _waitForLoopWidget() {
    if (!this.subEnabled) return;
    const found = document.querySelector('.loop-subscription-container');
    if (found) {
      this.loopWidget = found;
      this.syncLoopWidget();
      return;
    }
    const target = document.querySelector('[data-pm-loop-widget]') || this.productForm;
    if (!target) return;
    const observer = new MutationObserver(() => {
      const el = document.querySelector('.loop-subscription-container');
      if (el) {
        observer.disconnect();
        this.loopWidget = el;
        this.syncLoopWidget();
      }
    });
    observer.observe(target, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }

  syncLoopWidget() {
    if (!this.loopWidget) return;
    const radios = this.loopWidget.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    let targetRadio = null;
    if (this.isSubscription) {
      const needles = { 1: ['Abonnement 1', '30'], 2: ['Abonnement 2', '60'], 3: ['Abonnement 3', '90'] }[this.currentQuantity] || [];
      targetRadio = Array.from(radios).find((r) => {
        const name = r.dataset.name || '';
        return needles.some((n) => name === n || name.toLowerCase().includes(n));
      });
    } else {
      targetRadio = this.loopWidget.querySelector('.loop-one-time-purchase-option input[type="radio"]')
        || this.loopWidget.querySelector('input[type="radio"][data-name="One-time purchase"]')
        || Array.from(radios).find((r) => (r.dataset.name || '').toLowerCase().includes('one-time'));
    }
    if (targetRadio && !targetRadio.checked) {
      targetRadio.click();
    }
  }

  render() {
    this.renderBoxes();
    this.renderPriceDisplay();
    this.renderAtc();
    this.renderGifts();
    this.renderFooter();
    this.renderFormQuantity();
    this.root.classList.toggle('is-subscription-active', this.isSubscription);
    this.root.classList.toggle('is-onetime-active', !this.isSubscription);
  }

  renderBoxes() {
    this.boxes.forEach((box) => {
      const q = parseInt(box.dataset.quantity, 10);
      box.classList.toggle('pm-qty-box--active', q === this.currentQuantity);

      const badgeEl = box.querySelector('[data-pm-box-badge]');
      if (badgeEl) {
        const text = this.isSubscription ? this.badges.sub[q] : this.badges.ot[q];
        badgeEl.textContent = text;
        badgeEl.style.display = text ? '' : 'none';
      }

      const giftHint = box.querySelector('[data-pm-box-gifthint]');
      if (giftHint) {
        giftHint.style.display = this.isSubscription ? '' : 'none';
      }

      const priceEl = box.querySelector('[data-pm-box-price]');
      if (priceEl) {
        const table = this.isSubscription ? this.prices.sub : this.prices.ot;
        const formatted = this.formatPrice(table[q]);
        priceEl.textContent = q === 1 ? formatted : 'je ' + formatted;
      }
    });
  }

  renderPriceDisplay() {
    if (!this.priceDisplay) return;
    const q = this.currentQuantity;
    const unitTable = this.isSubscription ? this.prices.sub : this.prices.ot;
    const total = unitTable[q] * q;
    const unit = Math.round(total / (this.divisor * q));
    const compareTotal = this.prices.otCompare[q] ? this.prices.otCompare[q] * q : 0;

    if (this.totalPriceEl) this.totalPriceEl.textContent = this.formatPrice(total);
    if (this.unitPriceEl) this.unitPriceEl.textContent = this.formatPrice(unit);
    if (this.comparePriceEl) {
      if (compareTotal && compareTotal > total) {
        this.comparePriceEl.textContent = this.formatPrice(compareTotal);
        this.comparePriceEl.style.display = '';
      } else {
        this.comparePriceEl.style.display = 'none';
      }
    }
  }

  renderAtc() {
    if (!this.atcPricesEl) return;
    const q = this.currentQuantity;
    const unitTable = this.isSubscription ? this.prices.sub : this.prices.ot;
    const total = unitTable[q] * q;
    const compareTotal = this.prices.otCompare[q] ? this.prices.otCompare[q] * q : 0;

    this.atcPricesEl.hidden = false;
    this.atcPricesEl.removeAttribute('hidden');
    if (this.atcTotalEl) this.atcTotalEl.textContent = this.formatPrice(total);
    if (this.atcCompareEl) {
      if (compareTotal && compareTotal > total) {
        this.atcCompareEl.textContent = this.formatPrice(compareTotal);
        this.atcCompareEl.style.display = '';
      } else {
        this.atcCompareEl.style.display = 'none';
      }
    }
  }

  renderGifts() {
    if (!this.giftCards.length) return;
    this.giftCards.forEach((card) => {
      const idx = parseInt(card.dataset.giftIndex, 10);
      const unlocked = this.isSubscription && idx <= this.currentQuantity;
      card.classList.toggle('is-unlocked', unlocked);
      card.classList.toggle('is-locked', !unlocked);
    });

    if (this.giftModule) {
      this.giftModule.classList.toggle('is-onetime-mode', !this.isSubscription);
    }
    if (this.giftReactivateBtn) {
      if (this.isSubscription) {
        this.giftReactivateBtn.setAttribute('hidden', '');
      } else {
        this.giftReactivateBtn.removeAttribute('hidden');
      }
    }
  }

  renderFooter() {
    if (!this.footer || !this.footerToggleBtn || !this.footerToggleLabel) return;
    if (!this.subEnabled) {
      this.footer.hidden = true;
      return;
    }
    this.footer.hidden = false;

    const q = this.currentQuantity;
    if (this.isSubscription) {
      const total = this.prices.ot[q] * q;
      const tpl = this.footer.dataset.onetimeLabel || 'Einmaliger Kauf – {price}';
      this.footerToggleLabel.textContent = tpl.replace('{price}', this.formatPrice(total));
      this.footerToggleBtn.dataset.targetMode = 'onetime';
    } else {
      const otUnit = this.prices.ot[q];
      const subUnit = this.prices.sub[q];
      const discount = otUnit > 0 ? Math.round((1 - subUnit / otUnit) * 100) : 0;
      const tpl = this.footer.dataset.backToSubLabel || 'Zurück zum Abo – spare {discount}%';
      this.footerToggleLabel.textContent = tpl.replace('{discount}', discount);
      this.footerToggleBtn.dataset.targetMode = 'sub';
    }
  }

  renderFormQuantity() {
    if (this.formQtyInput) {
      this.formQtyInput.value = this.currentQuantity;
    }
  }

  formatPrice(cents) {
    const euros = cents / 100;
    const formatted = Number.isInteger(euros)
      ? euros.toFixed(0)
      : euros.toFixed(2).replace('.', ',');
    return '€' + formatted;
  }
}

function initPurchaseModules() {
  document.querySelectorAll('[data-purchase-module]').forEach((el) => {
    if (el.dataset.pmInitialized === 'true') return;
    el.dataset.pmInitialized = 'true';
    new PurchaseModule(el);
  });
}

document.addEventListener('DOMContentLoaded', initPurchaseModules);
document.addEventListener('shopify:section:load', initPurchaseModules);

customElements.define('bubble-count', BubbleCount);

/* LP-Geschenke: automatischer Warenkorb-Sync.
   Aktiv nur für Besucher der Landingpage (die LP hinterlegt die Config
   per paceLpGiftsSetConfig in localStorage, 7 Tage gültig). Gezählt
   werden ausschließlich Einmalkauf-Positionen mit dem Marker _lp, den
   nur das LP-Formular setzt. Geschenke werden mit dem Marker _lp_gift
   hinzugefügt und nur solche Positionen auch wieder entfernt. Kostenlos
   werden sie durch die Buy-X-get-Y-Automatikrabatte im Admin.
   Trigger: fetch/XHR-Wrapper auf /cart/add|change|update|clear, mit und
   ohne .js (das Theme ruft die Endpunkte ohne .js auf). */
(function () {
  var KEY = 'paceLpGifts';
  var TTL = 7 * 24 * 60 * 60 * 1000;
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?([\/?]|$)/;

  function readConfig() {
    try {
      var cfg = JSON.parse(localStorage.getItem(KEY));
      if (!cfg || !cfg.exp || cfg.exp < Date.now() || !cfg.pid || !cfg.gifts || !cfg.gifts.length) return null;
      return cfg;
    } catch (e) {
      return null;
    }
  }

  window.paceLpGiftsSetConfig = function (cfg) {
    if (!cfg || !cfg.pid || !cfg.gifts || !cfg.gifts.length) return;
    cfg.exp = Date.now() + TTL;
    try {
      localStorage.setItem(KEY, JSON.stringify(cfg));
    } catch (e) {}
  };

  var syncing = false;
  var queued = false;
  var debounceTimer = null;

  function refreshDrawer() {
    try {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    } catch (e) {}
  }

  function sync() {
    var cfg = readConfig();
    if (!cfg) return;
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var mainQty = 0;
        items.forEach(function (item) {
          if (item.product_id === cfg.pid && !item.selling_plan_allocation && item.properties && item.properties._lp) {
            mainQty += item.quantity;
          }
        });

        var adds = [];
        var removals = {};
        var hasRemovals = false;
        cfg.gifts.forEach(function (gift) {
          var line = null;
          items.forEach(function (item) {
            if (item.variant_id === gift.v && item.properties && item.properties._lp_gift) {
              line = item;
            }
          });
          var unlocked = mainQty >= gift.min;
          if (unlocked && !line) {
            adds.push({ id: gift.v, quantity: 1, properties: { _lp_gift: '1' } });
          }
          if (!unlocked && line) {
            removals[line.key] = 0;
            hasRemovals = true;
          }
        });

        /* Geschenke aus abgelösten Aktionen entfernen (z. B. der Frother, der
           durch die Dose ersetzt wurde). Betrifft nur _lp_gift-Positionen, die
           nicht mehr in der aktuellen Config stehen - gekaufte Exemplare tragen
           den Marker nicht und bleiben unangetastet. */
        var activeVariants = {};
        cfg.gifts.forEach(function (gift) {
          activeVariants[gift.v] = true;
        });
        items.forEach(function (item) {
          if (item.properties && item.properties._lp_gift && !activeVariants[item.variant_id]) {
            removals[item.key] = 0;
            hasRemovals = true;
          }
        });

        if (!adds.length && !hasRemovals) {
          syncing = false;
          if (queued) {
            queued = false;
            sync();
          }
          return;
        }

        var chain = Promise.resolve();
        if (adds.length) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: adds })
            });
          });
        }
        if (hasRemovals) {
          chain = chain.then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ updates: removals })
            });
          });
        }

        return chain.then(function () {
          syncing = false;
          if (window.location.pathname === '/cart') {
            window.location.reload();
            return;
          }
          refreshDrawer();
          if (queued) {
            queued = false;
            sync();
          }
        });
      })
      .catch(function () {
        syncing = false;
      });
  }

  window.paceLpGiftsSync = sync;

  function scheduleSync() {
    if (syncing) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 150);
  }

  /* Cart-Mutationen des Themes und von Apps abfangen (fetch und XHR) */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    var result = origFetch.apply(this, arguments);
    if (CART_MUTATION.test(u) && !syncing) {
      result.then(scheduleSync, function () {});
    }
    return result;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._paceCartMutation = CART_MUTATION.test(url || '');
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._paceCartMutation) {
      this.addEventListener('load', function () {
        if (!syncing) scheduleSync();
      });
    }
    return origSend.apply(this, arguments);
  };

  /* Zusätzlicher Trigger über Theme-Events, falls ein Add-Pfad nicht
     über die Wrapper läuft */
  document.addEventListener('theme:cart:added', function () {
    if (!syncing) scheduleSync();
  });

  /* Config übernehmen, falls das LP-Inline-Script vor custom.js lief */
  if (window.paceLpGiftsPending) {
    window.paceLpGiftsSetConfig(window.paceLpGiftsPending);
    window.paceLpGiftsPending = null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(sync, 300);
    });
  } else {
    setTimeout(sync, 300);
  }
})();
